import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
`;

export const FontList = styled.div`
	display: flex;
	flex-direction: column;
`;

export const FontCard = styled.div<{ $isDragOver?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 4px 0;
	min-height: 40px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	transition: background-color 0.15s ease;
	background: ${({ theme, $isDragOver }) => ($isDragOver ? `${theme.blue[500]}0d` : 'transparent')};

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}
`;

export const FontTypeContainer = styled.div`
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.gray[600]};
	flex-shrink: 0;
`;

export const FontNameContainer = styled.div`
	width: 180px;
	min-width: 0;
	flex-shrink: 0;
	overflow: hidden;

	> * {
		margin-top: 0;
	}
`;

export const UploadingLabel = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	font-style: italic;
	padding: 4px 6px;
`;

export const WeightsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	flex: 1;
`;

export const WeightPill = styled.label<{ $checked: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 3px 7px;
	border-radius: 6px;
	font-size: 12px;
	border: 1px solid ${({ theme, $checked }) => ($checked ? theme.blue[500] : theme.gray[200])};
	background-color: ${({ theme, $checked }) => ($checked ? `${theme.blue[500]}20` : theme.gray[0])};
	color: ${({ theme, $checked }) => ($checked ? theme.blue[500] : theme.gray[700])};
	transition: all 0.15s ease;

	&:hover {
		border-color: ${({ theme }) => theme.blue[500]};
		background-color: ${({ theme }) => `${theme.blue[500]}20`};
	}

	input {
		display: none;
	}
`;

export const RemoveButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border: none;
	border-radius: 6px;
	background-color: transparent;
	color: ${({ theme }) => theme.gray[400]};
	transition: opacity 0.15s ease, color 0.15s ease;
	flex-shrink: 0;
	margin-left: auto;
	opacity: 0;

	${FontCard}:hover & {
		opacity: 1;
	}

	&:hover:not(:disabled) {
		color: ${({ theme }) => theme.red[500]};
	}

	&:disabled {
		display: none;
	}
`;

export const FileTileLabel = styled.span``;

export const FileTileHoverLabel = styled.span`
	display: none;
`;

export const FileTile = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 24px;
	padding: 0 10px;
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[700]};
	transition: all 0.15s ease;

	&:hover {
		border-color: ${({ theme }) => theme.blue[500]};
		color: ${({ theme }) => theme.blue[500]};
		background: ${({ theme }) => `${theme.blue[500]}10`};

		${FileTileLabel} {
			display: none;
		}
		${FileTileHoverLabel} {
			display: inline;
		}
	}
`;

export const UploadButton = styled.button`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 4px 10px;
	border: 1px dashed ${({ theme }) => theme.gray[400]};
	border-radius: 6px;
	background-color: transparent;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 12px;
	transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;

	&:hover {
		border-color: ${({ theme }) => theme.blue[500]};
		color: ${({ theme }) => theme.blue[500]};
		background-color: ${({ theme }) => `${theme.blue[500]}10`};
	}
`;

export const AddGoogleFontLink = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 18px;
	height: 44px;
	padding: 0 12px;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[700]};
	font-size: 13px;
	font-weight: 500;
	transition: background-color 0.15s ease;

	&:hover {
		background: ${({ theme }) => theme.gray[200]};
	}
`;

export const AddGoogleFontSubtitle = styled.span`
	font-size: 12px;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[600]};
	margin-left: 2px;
`;

export const DropZone = styled.div<{ $isDragging: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 96px;
	padding: 10px 24px;
	border-radius: 8px;
	margin-top: 4px;
	border: 2px dashed
		${({ theme, $isDragging }) => ($isDragging ? theme.gray[600] : theme.gray[400])};
	background: ${({ theme, $isDragging }) =>
		$isDragging ? `${theme.gray[800]}10` : theme.gray[100]};
	color: ${({ theme }) => theme.gray[600]};
	transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
		border-color: ${({ theme }) => theme.gray[600]};
		color: ${({ theme }) => theme.gray[600]};
	}
`;

export const DropZoneLabel = styled.span`
	font-size: 13px;
	font-weight: 500;
`;

export const DropZoneFormats = styled.span`
	font-size: 11px;
`;
